// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import {
  type CompanyMatchInfo,
  type CompanyMatchInfoWireFormat,
  NewCompanyMatchInfo,
} from '../CompanyMatchInfo/CompanyMatchInfo';

export class DispatchCustomerToCompanyPossibleMatches {
  readonly dispatchCustomerId: string;
  readonly dispatchCustomerName: string;
  readonly possibleCompanyMatches: CompanyMatchInfo[];

  constructor(data: { [key: string]: any } = {}) {
    this.dispatchCustomerId =
      data.dispatchCustomerId === undefined ? NIL_UUID : data.dispatchCustomerId;
    this.dispatchCustomerName =
      data.dispatchCustomerName === undefined ? '' : data.dispatchCustomerName;
    this.possibleCompanyMatches = (data.possibleCompanyMatches ?? []).map(
      (possibleCompanyMatches: any) => NewCompanyMatchInfo(possibleCompanyMatches),
    );
  }

  static zero(): DispatchCustomerToCompanyPossibleMatches {
    const zeroValues: ExcludeMethodsDeep<DispatchCustomerToCompanyPossibleMatches> = {
      dispatchCustomerId: NIL_UUID,
      dispatchCustomerName: '',
      possibleCompanyMatches: [],
    };
    return new DispatchCustomerToCompanyPossibleMatches(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type DispatchCustomerToCompanyPossibleMatchesWireFormat = {
  dispatchCustomerId: string;
  dispatchCustomerName: string;
  possibleCompanyMatches: CompanyMatchInfoWireFormat[];
};

type NewDispatchCustomerToCompanyPossibleMatchesProps = PartialDeep<
  DispatchCustomerToCompanyPossibleMatches,
  { recurseIntoArrays: true }
>;
export const NewDispatchCustomerToCompanyPossibleMatches: (
  props: NewDispatchCustomerToCompanyPossibleMatchesProps,
) => DispatchCustomerToCompanyPossibleMatches = (props) =>
  new DispatchCustomerToCompanyPossibleMatches(props);

type NewDispatchCustomerToCompanyPossibleMatchesFromWireFormatProps = PartialDeep<
  DispatchCustomerToCompanyPossibleMatchesWireFormat,
  { recurseIntoArrays: true }
>;
export const NewDispatchCustomerToCompanyPossibleMatchesFromWireFormat: (
  props: NewDispatchCustomerToCompanyPossibleMatchesFromWireFormatProps,
) => DispatchCustomerToCompanyPossibleMatches = (props) =>
  new DispatchCustomerToCompanyPossibleMatches(props);
